import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls window to top whenever the route (pathname) changes.
// Hash links (e.g. #section) are intentionally ignored so anchor scroll still works.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);
  return null;
}
